module.exports = __webpack_public_path__ + "media/images/steps/svg/235-curriculum-vitae-b0fa72af9e41e52b5e7ba26477125724.svg";